import React from "react";

const Footer = () => {
    return (
        <div className="list-books-title">
            <p>Footer</p>
        </div>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/modules/Footer.js